<template>
  <v-dialog v-model="dialog" persistent scrollable>
    <div class="mt-4">
      <v-card>
        <v-card-title>
          <h3>Previsualización de datos cargados</h3>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-divider></v-divider>
            <v-col class="col-12">
              <v-data-table
                :headers="headers"
                :items="listadoProgramacion"
                class="elevation-0 border"
                multi-sort
                item-key="idprogramacioncomedor"
                :mobile-breakpoint="0"
                :item-class="row_classes"
                :items-per-page="pagina"
                no-results-text="No se encontraron datos"
                no-data-text="No se encontraron datos"
              >
                <template v-slot:top v-if="showEliminar">
                  <v-toolbar flat color="white">
                    <v-spacer></v-spacer>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <div class="text-center">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn small v-on="on" fab dark color="red" @click="deleteDuplicados()">
                            <v-icon small dark>fas fa-trash</v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar Duplicados</span>
                      </v-tooltip>
                    </div>
                  </v-toolbar>
                  <v-divider></v-divider>
                </template>
                <template v-slot:item.programareleccion="{ item }">
                  <v-icon color="red" small v-if="item.programareleccion == 0">fas fa-times</v-icon>
                  <v-icon color="green" small v-else-if="item.programareleccion == 1">fas fa-check</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closePopup()">Cerrar</v-btn>
          <v-btn color="info" submit @click="guardar()">Guardar</v-btn>
        </v-card-actions>
        <v-snackbar v-model="snackbar" :timeout="timeout">
          {{ text }}
          <v-btn color="info" text @click="snackbar = false">
            Cerrar
          </v-btn>
        </v-snackbar>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import ProgramacionMenuService from '../services/ProgramacionMenuService';
export default {
  name: 'GestionProgramacionMenuPopup',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    listadoProgramacion: {
      type: Array
    }
  },
  data: () => ({
    snackbar: false,
    timeout: 3000,
    text: '',
    showEliminar: false,
    headers: [
      { text: 'idcliente', value: 'idcliente', width: '150' },
      { text: 'idprogramacioncomedor', value: 'idprogramacioncomedor', width: '150' },
      { text: 'fecha', value: 'fecha', width: '150' },
      { text: 'idplato', value: 'idplato', width: '150' },
      { text: 'tipoplato', value: 'tipoplato', width: '150' },
      { text: 'stockadicional', value: 'stockadicional', width: '150' },
      { text: 'comedor', value: 'comedor', width: '150' },
      { text: 'programareleccion', value: 'programareleccion', width: '150' },
      { text: 'inicioprogramareleccion', value: 'inicioprogramareleccion', width: '150' },
      { text: 'finprogramareleccion', value: 'finprogramareleccion', width: '150' }
    ],
    programacionMenuService: null
  }),
  computed: {
    pagina() {
      if (screen.width <= 600) return 5;
      else return 15;
    }
  },
  methods: {
    openPopup() {
      this.$emit('open');
    },
    closePopup() {
      this.$emit('close');
    },
    row_classes(item) {
      return { 'color-error': item.error };
    },
    deleteDuplicados() {
      this.$emit('deleteDuplicados');
    },
    guardar() {
      this.$emit('guardar');
    }
  },
  async mounted() {
    this.programacionMenuService = this.$httpService(new ProgramacionMenuService(), this);
  }
};
</script>
